import { AlertCircle, ShieldCheck } from 'lucide-react';

const getStatusLabel = (status: string) => {
  switch (status) {
    case 'draft': return 'BROUILLON';
    case 'pending': return 'EN ATTENTE';
    case 'validated': return 'VALIDÉ';
    case 'rejected': return 'REFUSÉ';
    default: return status.toUpperCase();
  }
};

interface TimesheetHeaderProps {
  sheetStatus: string;
  employeeName: string | undefined;
  isDelegateMode: boolean;
  isLocked: boolean;
  rejectionReason: string | null;
  onBack: () => void;
}

export function TimesheetHeader({ sheetStatus, employeeName, isDelegateMode, isLocked, rejectionReason, onBack }: TimesheetHeaderProps) {
  return (
    <>
      {/* HEADER */}
      <div style={{ background: isDelegateMode ? '#fff3cd' : '#fff', padding: '20px 24px', boxShadow: '0 2px 4px rgba(0,0,0,0.1)', display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: isDelegateMode ? '3px solid #ffc107' : '1px solid #e2e8f0' }}>
        <button onClick={onBack} style={{ border: 'none', background: 'transparent', fontSize: '1.2rem', cursor: 'pointer', display:'flex', alignItems:'center', gap:'8px', color:'#64748b' }}>← Retour</button>
        <div style={{ textAlign: 'right' }}>
          {isDelegateMode && <div style={{ fontSize: '0.85rem', color: '#856404', fontWeight: '800', textTransform:'uppercase', marginBottom:'4px' }}>MODE DÉLÉGUÉ</div>}
          <div style={{ fontWeight: '700', fontSize: '1.25rem', color: '#1e293b' }}>
            {employeeName}
            {isLocked && <span style={{ marginLeft: '12px', background: sheetStatus === 'validated' ? '#dcfce7' : '#fef3c7', color: sheetStatus === 'validated' ? '#166534' : '#b45309', padding: '6px 12px', borderRadius: '8px', fontSize: '0.85rem', display: 'inline-flex', alignItems: 'center', gap: '6px' }}><ShieldCheck size={16} /> {getStatusLabel(sheetStatus)}</span>}
            {sheetStatus === 'rejected' && <span style={{ marginLeft: '12px', background: '#fef2f2', color:'#dc2626', padding: '6px 12px', borderRadius: '8px', fontSize: '0.85rem' }}>REFUSÉ - À corriger</span>}
          </div>
        </div>
      </div>

      {/* ALERTE REJET */}
      {sheetStatus === 'rejected' && rejectionReason && (
        <div style={{ maxWidth: '1400px', margin: '0 auto', padding: '0 24px' }}>
          <div style={{
            background: '#fef2f2',
            border: '1px solid #fecaca',
            borderRadius: '12px',
            padding: '16px 20px',
            marginTop: '16px',
            display: 'flex',
            alignItems: 'flex-start',
            gap: '12px'
          }}>
            <AlertCircle size={24} style={{ color: '#dc2626', flexShrink: 0, marginTop: '2px' }} />
            <div>
              <div style={{ fontWeight: '700', color: '#dc2626', marginBottom: '4px' }}>Feuille rejetée par la direction</div>
              <div style={{ color: '#991b1b', fontSize: '0.95rem' }}><strong>Motif :</strong> {rejectionReason}</div>
              <div style={{ color: '#b91c1c', fontSize: '0.85rem', marginTop: '8px', fontStyle: 'italic' }}>
                Veuillez corriger les éléments mentionnés puis re-signer et soumettre à nouveau.
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
